import { ref } from "vue"
import { defineStore } from "pinia"
import { Preferences } from "@capacitor/preferences"

export const useDataPolicyStore = defineStore("data-policy", () => {
	const hasAgreedToDataPolicy = ref(false)

	async function setAgreedToDataPolicy(agreed) {
		hasAgreedToDataPolicy.value = agreed
		// if (localStorage) {
		// 	localStorage.setItem("gv-data-policy-agreed", agreed ? "true" : "false")
		// }
		await Preferences.set({
			key: "gv-data-policy-agreed",
			value: agreed ? "true" : "false",
		})
	}

	async function loadDataPolicyAgreement() {
		// if (localStorage) {
		// 	const agreed = localStorage.getItem("gv-data-policy-agreed")
		// 	hasAgreedToDataPolicy.value = agreed === "true"
		// }
		const { value } = await Preferences.get({ key: "gv-data-policy-agreed" })
		hasAgreedToDataPolicy.value = value === "true"
		// console.log(hasAgreedToDataPolicy.value)
		// return hasAgreedToDataPolicy.value
	}

	function hasAgreed() {
		return hasAgreedToDataPolicy.value
	}

	return {
		hasAgreedToDataPolicy,
		setAgreedToDataPolicy,
		loadDataPolicyAgreement,
		hasAgreed,
	}
})
